import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesOrderContentsComponent } from './sales-order-contents.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { VaBadgeModule, VaIconModule } from '@vendasta/uikit';
import { SalesOrderPackageDropdownItemComponent } from './package-dropdown/package-dropdown-item/package-dropdown-item.component';
import { SalesOrderPackageDropdownComponent } from './package-dropdown/package-dropdown.component';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    SalesOrderContentsComponent,
    SalesOrderPackageDropdownItemComponent,
    SalesOrderPackageDropdownComponent,
  ],
  exports: [SalesOrderContentsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    VaIconModule,
    VaBadgeModule,
    MatMenuModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyTooltipModule,
    MatExpansionModule,
  ],
})
export class SalesOrderContentsModule {}
